import { SectionTitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';

import type { ContactPreferencesProps } from './types';
import { ContactPreferencesAccordion } from './components/ContactPreferencesAccordion';

export * from './types';

export const ContactPreferences: FC<ContactPreferencesProps> = (props) => {
  const { mode, onChangeContactPreferenceClick, emails } = props;
  const { translate } = useTranslation();

  return (
    <>
      <SectionTitle>{translate('mt.preferences.contact.title')}</SectionTitle>

      <ContactPreferencesAccordion
        mode={mode}
        preferences={emails}
        onChangeContactPreferenceClick={onChangeContactPreferenceClick}
      />
    </>
  );
};
